module.exports = __webpack_public_path__ + "img/charging-pole.e29c26a1.png";